import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionItemCustomViewsApi = {
    getTrialInstitutionItemCustomViews: (trialId: number): Observable<Dtos.GetTrialInstitutionItemCustomViewsResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemCustomViews = new Dtos.GetTrialInstitutionItemCustomViews();
        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemCustomViewsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionItemCustomViewById: (id: number): Observable<Dtos.GetTrialInstitutionItemCustomViewByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemCustomViewById = new Dtos.GetTrialInstitutionItemCustomViewById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemCustomViewByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionItemCustomViewDataEntryById: (id: number): Observable<Dtos.GetTrialInstitutionItemCustomViewDataEntryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemCustomViewDataEntryById = new Dtos.GetTrialInstitutionItemCustomViewDataEntryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemCustomViewDataEntryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionItemCustomView: (trialInstitutionItemCustomView: Dtos.TrialInstitutionItemCustomView): Observable<Dtos.SetTrialInstitutionItemCustomViewResponse> => {

        let request: Dtos.SetTrialInstitutionItemCustomView = new Dtos.SetTrialInstitutionItemCustomView();

        request.trialInstitutionItemCustomView = trialInstitutionItemCustomView;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionItemCustomViewResponse> = client.post(request);

        return Observable.from(response);

    },
    setTrialInstitutionItemCustomViewDataEntryById: (trialInstitutionItemCustomView: Dtos.TrialInstitutionItemCustomView): Observable<Dtos.PostTrialInstitutionItemCustomViewDataEntryByIdResponse> => {

        let request: Dtos.PostTrialInstitutionItemCustomViewDataEntryById = new Dtos.PostTrialInstitutionItemCustomViewDataEntryById();

        request.id = trialInstitutionItemCustomView.id
        request.trialInstitutionItemCustomView = trialInstitutionItemCustomView;

        // send request
        const response: Promise<Dtos.PostTrialInstitutionItemCustomViewDataEntryByIdResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialInstitutionItemCustomView: (trialId: number, institutionId: number, formTemplateId: number): Observable<Dtos.CreateTrialInstitutionItemCustomViewResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionItemCustomView = new Dtos.CreateTrialInstitutionItemCustomView();

        request.trialId = trialId;
        request.institutionId = institutionId;
        request.formTemplateId = formTemplateId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionItemCustomViewResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}